import React, { useEffect, useState, useContext } from 'react';
import axios from 'axios';
import { useParams } from "react-router-dom";
import { useHistory } from 'react-router';
import Doctors from './Doctors';
import { unauthHeaders } from '../../utils/API';
import { ErrorAlert } from '../../utils/Alerts';
import UserContext from '../../UserContext';
import { categryTypeObj, payTypeObj } from '../../utils/enums';

const DoctorsContainer = () => {
    const history = useHistory();

    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState();
    const [doctorsList, setDoctorsList] = useState([]);
    const [selectedSpecialisation, setSelectedSpecialisation] = useState();
    const [isOpenCabinetsList, setIsOpenCabinetsList] = useState(false);
    const [selectedCabinet, setSelectedCabinet] = useState();
    const [selectedCabinetName, setSelectedCabinetName] = useState('');
    const [typeServices, setTypeServices] = useState(''); // researches || navigationItems

    const {
        setSpecializationId,
        setSpecializationName,
        specializationName,
        setPayType,
        setIsDisabledNextBtn,
        isDisabledNextBtn,
        setSendingCompanyId,
    } = useContext(UserContext);

    const { clinicId, buildingId, serviceId, serviceName, isReferral } = useParams();
    const userId = sessionStorage.getItem('userId');



    const getDoctorsList = () => {
        setIsLoading(true);
        const payType = [payTypeObj[isReferral]];
        axios.get(`${process.env.REACT_APP_API}api/v1.0/doctors?UserId=${userId}&BuildingId=${buildingId}&ClinicId=${clinicId}&CategoryType=${categryTypeObj[serviceId]}&SearchType=All&SearchCategory=All&OnlyPersonalSchedule=false&PayType=${payType}`, {
            headers: {
                ...unauthHeaders,
                Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            }
        })
            .then((res) => {
                setIsLoading(false);
                if (res.data.navigationItems) {
                  setTypeServices('navigationItems');
                  setDoctorsList(res.data.navigationItems);
                }
                if (res.data.researches) {
                  setTypeServices('researches');
                  setDoctorsList(res.data.researches);
                }
            })
            .catch((err) => {
                console.log(err);
                setErrorMessage(err.response.data.message);
                setIsLoading(false);
            });
    }

    useEffect(() => {
        if (userId) {
            getDoctorsList();
        }
    }, [])

    const handleClickSpecialisationCard = (specialisationId, specialisationName, cabinets) => {
        if (cabinets && cabinets.length >= 1) { // Если есть вложенные кабинеты
            setSelectedSpecialisation(specialisationId);
            setIsOpenCabinetsList(!isOpenCabinetsList);
            setSpecializationName(specialisationName);
        } else {
            handleClickCardDoctor(specialisationId, specialisationName);
        }
    }

    const handleClickCabinet = (cabinetId, cabinetName) => {
        setSelectedCabinet(cabinetId);
        setSelectedCabinetName(cabinetName);
        setIsOpenCabinetsList(false);
        setIsDisabledNextBtn(false);
        setTimeout(() => {
            handleClickCardDoctor(selectedSpecialisation, specializationName, cabinetId);
        }, 200);
    }

    const handleClickCardDoctor = (specialisationId, doctor, cabinetId) => {
        setSpecializationId(specialisationId);
        setSpecializationName(doctor);

        if (isReferral === '1') {
            history.push(`${process.env.REACT_APP_WEBSITE_NAME}/lk/direct/${clinicId}/${buildingId}/${specialisationId}/${cabinetId}/${doctor}/${categryTypeObj[serviceId]}/${isReferral}/${typeServices}`);
        } else {
            setPayType('Cash');
            setSendingCompanyId(null);
            history.push(`${process.env.REACT_APP_WEBSITE_NAME}/lk/schedule/${clinicId}/${specialisationId}/${cabinetId}/${doctor}/${categryTypeObj[serviceId]}/${buildingId}/${typeServices}`);
        }

    }

    const handleClickNextBtn = () => {
        if (isDisabledNextBtn) {
            return
        }
        setIsDisabledNextBtn(true);

      //   if (isReferral === '1') {
      //     history.push(`${process.env.REACT_APP_WEBSITE_NAME}/lk/direct/${clinicId}/${buildingId}/${specialisationId}/${cabinetId}/${doctor}/${serviceId}/${isReferral}/${typeServices}`);
      // } else {
      //     setPayType('Cash');
      //     setSendingCompanyId(null);
      //     history.push(`${process.env.REACT_APP_WEBSITE_NAME}/lk/schedule/${clinicId}/${specialisationId}/${cabinetId}/${doctor}/${categryTypeObj[serviceId]}/${buildingId}/${typeServices}`);
      // }
        // if (serviceId === '0' && isReferral === '1') {
            history.push(`${process.env.REACT_APP_WEBSITE_NAME}/lk/direct/${clinicId}/${buildingId}/${selectedSpecialisation}/${selectedCabinet}/${specializationName}/${serviceId}`);
        // } else {
        //     // setPayType('Cash');
        //     history.push(`${process.env.REACT_APP_WEBSITE_NAME}/lk/schedule/${clinicId}/${selectedSpecialisation}/${selectedCabinet}/${specializationName}/${serviceId}/${buildingId}`);
        // }
    }

    return (
        <>
            {errorMessage && <ErrorAlert errorMessage={errorMessage} setErrorMessage={setErrorMessage} />}
            <Doctors
                serviceName={serviceName}
                isLoading={isLoading}
                doctorsList={doctorsList}
                handleClickSpecialisationCard={handleClickSpecialisationCard}
                selectedSpecialisation={selectedSpecialisation}
                handleClickCabinet={handleClickCabinet}
                selectedCabinet={selectedCabinet}
                selectedCabinetName={selectedCabinetName}
                isOpenCabinetsList={isOpenCabinetsList}
                handleClickNextBtn={handleClickNextBtn}
            />
        </>
    )
}

export default DoctorsContainer;
